<newsletter-form class="block"
                 [source]="component.source"
                 [successMessage]="component.successMessage"/>